import React from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Col
} from 'react-bootstrap'

// includes
import VendorDetailsFields from './FormVendors__Details'

function VendorsFormContentView(props) {
    const { authState, formik, countries } = props

    return (
        <React.Fragment>
            {/* app card */}
            <div className="app-card mb-3 mb-lg-4">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize">Details</p>
                </div>

                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                    <Col xs={12} md={9} lg={6} className="px-0">
                        <VendorDetailsFields
                            authState={authState}
                            formik={formik}
                            countries={countries}
                        />
                    </Col>
                </div>
            </div>
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(VendorsFormContentView)